import { Page } from '@/core/architecture'

import { ThreadDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ThreadDetail Page
 * Implemented as a practical sample.
 */
export const ThreadDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ThreadDetailTemplate state={state} {...actions} />
}
